export default {
  api: {
    host: '//hairio.tornionlaaksonsahko.fi/api',
  },
  kml: {
    url: 'https://hairio.tornionlaaksonsahko.fi/api/kml',
  },
};



// WEBPACK FOOTER //
// ./src/config/production.js